import useModifiers from 'hooks/useModifiers';

export enum PillModifier {
  NEUTRAL = 'neutral',
  HOVER = 'hover',
  PROGRESS = 'progress',
  ACTIVE = 'active',
  ERROR = 'error',
  TABLE = 'table',
  OUTLINE = 'outline',
  MONOSPACE = 'monospace',
  GREEN = 'green',
  BLUE = 'blue',
}

export interface PillProps {
  value: string;
  modifiers: PillModifier[];
  icon?: React.ReactElement;
}

function Pill(props: PillProps) {
  const mods = useModifiers(props.modifiers);

  return (
    <div className={`ct_pill ${mods}`}>
      {props.icon && (
        <div className="ct_pill-icon">{props.icon}</div>
      )}
      <span>{props.value}</span>
    </div>
  );
}

Pill.defaultProps = { ...{} };

export default Pill;
